import { render, staticRenderFns } from "./ObjectViewer.vue?vue&type=template&id=4ef8878c&scoped=true"
import script from "./ObjectViewer.vue?vue&type=script&lang=ts"
export * from "./ObjectViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8878c",
  null
  
)

export default component.exports